import React from 'react';
import * as firebase from 'firebase';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
  Link,
  Redirect
} from "react-router-dom";
import './css/AffiliateSearchResult.css';

export function AffiliateSearchResult(props) {

  var firestore = firebase.firestore();
  var user = firebase.auth().currentUser;



  return (
    <div className="AffiliateSearch">
      <div className="SearchResultHeader">
        <p className="SearchResultName">{props.name}</p>
        <Link className="AffiliateLink" to={{ pathname: `/Affiliate/${props.name}`, state: { name: props.name, id: props.id } }}>
          Visit
        </Link>
      </div>

      <div className="SearchResultBody">
        <img className="SearchResultPic" src={props.photos} />
        <p className="SearchResultDescription">{props.description}</p>
      </div>

      <div className="AffiliateTagsContainer">
        <div className="AffiliateTags">
          {props.tags.map((tag) => (
            <div>
              <button className="AffiliateIndividualTag">{tag}</button>
            </div>


          ))}
        </div>

      </div>
    </div>
  );
}